export default __webpack_public_path__ + "static/media/search.15c8a6e0.svg";